// extracted by mini-css-extract-plugin
module.exports = {"base":"Shortcut-module-base","key":"Shortcut-module-key","chainIndicator":"Shortcut-module-chain-indicator"};